import React from 'react';

import { Paragraph } from '../Typography';
import type { IconName } from '@/lib/icons';
import { icons } from '@/lib/icons';
import type { PageLevelAlertTypes } from '@/types';
import { ParentContainer } from '../Containers';
import { PageLevelAlertContainer } from './StyledComponents';

interface PageLevelAlertProps {
  alertContent: React.ReactNode;
  pageLevelAlertVariant: PageLevelAlertTypes;
  icon: IconName;
}

export const PageLevelAlert = ({
  alertContent,
  pageLevelAlertVariant,
  icon,
}: PageLevelAlertProps): React.ReactElement => {
  const IconComponent = icons[icon];

  return (
    <PageLevelAlertContainer
      pageLevelAlertVariant={pageLevelAlertVariant}
      data-testid="page-level-alert-container"
    >
      {IconComponent && (
        <ParentContainer
          containerWidth="24px"
          containerHeight="24px"
          data-testid="icon-container"
        >
          <IconComponent />
        </ParentContainer>
      )}
      <Paragraph margin="0 8px">{alertContent}</Paragraph>
    </PageLevelAlertContainer>
  );
};
